import gql from 'graphql-tag';

export default gql`
  mutation removeByIdUserMutation($_id: MongoID!) {
    removeByIdUserMutation(_id: $_id) {
      recordId
      message
      title
    }
  }
`;
